module.exports = __webpack_public_path__ + "img/golden1.5269b064.svg";